<template>
  <div class="irp-field-grid" data-testid="irp-field-grid">
    <div
      v-for="(field, index) in visibleFields"
      :key="`${field.column}_${index}`"
      class="irp-field-grid__field"
    >
      <IRPFieldGridText class="irp-field-grid__label" :text="field.name" />
      <IRPFieldGridText
        class="irp-field-grid__value"
        :text="formatFieldValue(field)"
        :is-masked="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { RecordFieldType } from '@/types/individual_record';
import { sortByKey } from '@/utils';

import { formatFieldValue, hasFieldValue } from './irp';
import IRPFieldGridText from './IRPFieldGridText.vue';

const { fields } = defineProps<{
  fields: RecordFieldType[];
}>();

const visibleFields = computed(() =>
  fields.filter(hasFieldValue).toSorted(sortByKey('name')),
);
</script>

<style lang="pcss" scoped>
@reference "../../../css/theme.css";

.irp-field-grid {
  @apply grid gap-x-24 gap-y-16;
  grid-template-columns: subgrid;
}

.irp-field-grid__field {
  @apply flex min-w-0 flex-col gap-4;
}

.irp-field-grid__label {
  @apply min-w-0 text-sm font-semibold text-neutral-text-weak;
}

.irp-field-grid__value {
  @apply min-w-0 text-base text-neutral-text;
}
</style>
